import React, { useEffect } from 'react';

import { useEventing } from 'commons/eventing';
import { useAuthentication } from 'commons/hooks';

import HistoryContainer from './HistoryContainer';

interface Props {
  isOpen?: boolean;
  documentId?: number;
}

export const HistoryTab = ({ documentId }: Props) => {
  const eventing = useEventing();
  useEffect(() => {
    if (!documentId) {
      return;
    }
    eventing.screen('editor.view.history');
  }, [documentId]);

  const { applicationId }: any = useAuthentication();

  if (!documentId) {
    return null;
  }
  return <HistoryContainer applicationId={applicationId} documentId={documentId} />;
};
